/**
 * `<ChatToolPulse>` — Architect-visual live tool-call pulse primitive
 * (Y bundle / spec §10.1.a + migration 131).
 *
 * Renders ⚡ + a tool label as a muted-italic assistant bubble row. Used by
 * surfaces with tool-using agents (currently reactive-viz; future surfaces
 * gain it cheaply by composing this primitive).
 *
 * **Two pulse sources, one render:**
 * - `localPulse` — set during the active mount by the SSE event reader.
 *   Fresh; takes precedence over the persisted server pulse.
 * - `serverPulse` — set by `useAiChatThread`'s loadLatest from `latest_tool_pulse`
 *   in the DB. Surfaces the agent's current step after click-away/back.
 *
 * The component renders nothing when both are null. When either is set, it
 * shows a single bubble with the chosen label (local preferred). This means
 * surfaces don't need their own pulse-fallback logic.
 */

import type { JSX } from "react";

export type ChatToolPulseProps = {
  localPulse: string | null;
  serverPulse: string | null;
};

export function ChatToolPulse(props: ChatToolPulseProps): JSX.Element | null {
  const label = props.localPulse ?? props.serverPulse;
  if (!label) return null;
  return (
    <div className="opAiChatRow opAiChatRowAssistant">
      <div className="opAiChatMeta">⚡</div>
      <div className="opAiChatBubbleAssistant">
        <div className="opAiChatProse" style={{ fontStyle: "italic", opacity: 0.7 }}>
          {label}
        </div>
      </div>
    </div>
  );
}
